import { IconPropType } from ".";

export const ProcessingIcon: React.FC<IconPropType> = ({ width = 36, height = 36, className = '', style }) => (
<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 36 36" fill="none" style={style}>
  <path d="M17.6 33.2C26.2156 33.2 33.2 26.2156 33.2 17.6C33.2 8.98436 26.2156 2 17.6 2C8.98436 2 2 8.98436 2 17.6C2 26.2156 8.98436 33.2 17.6 33.2Z" stroke="url(#paint0_linear_730_7137)" strokeWidth="4">
    <animateTransform
      attributeName="transform"
      type="rotate"
      from="0 18 18"
      to="360 18 18"
      dur="1s"
      repeatCount="indefinite"
    />
  </path>
  <defs>
    <linearGradient id="paint0_linear_730_7137" x1="2" y1="2" x2="26.2" y2="2" gradientUnits="userSpaceOnUse">
      <stop stop-color="var(--zpr-color-brand-primary)"/>
      <stop offset="0.5" stop-color="var(--zpr-color-brand-primary)"/>
      <stop offset="1" stop-color="transparent"/>
    </linearGradient>
  </defs>
</svg>
);